import React, { Component } from 'react';
import { Edit, SimpleForm, TextInput, required } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import Title from './Title';
import SelectArrayInput from './SelectArrayInput';
import RoleToolbar from './RoleToolbar';

const styles = {
  root: {
    marginTop: '24px',
  },
};

const permissionChoices = [
  { id: 'brands', name: 'Car Brand' },
  { id: 'models', name: 'Car Model' },
  { id: 'promotions', name: 'Promotion' },
  { id: 'vouchers', name: 'Voucher' },
];

class EditForm extends Component {
  render() {
    const { classes, dispatch, ...props } = this.props;
    return (
      <Edit title={<Title />} {...props}>
        <SimpleForm toolbar={<RoleToolbar />}>
          <TextInput source="name" validate={required()} />
          <SelectArrayInput label="Role Permission" choices={permissionChoices} source="permission" />
        </SimpleForm>
      </Edit>
    );
  }
}

export default withStyles(styles)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/Role/EditForm.js